import { Drawer, Point, StyleForLine, StyleForText } from "@common/components/Rendering";
import { ArrowId } from "../ViewportStyles";

interface CoordinateSystemSettings {
    origin: Point;
    axisLength: number;
    horizontalAxisLabel: string;
    verticalAxisLabel: string;
    axisStyle: StyleForLine;
    labelStyle: StyleForText;
}

export const drawCoordinateSystem = (drawer: Drawer<ArrowId>, sett: CoordinateSystemSettings) => {
    const [hor, ver] = sett.origin;

    drawer.drawLine([hor, ver], [hor + sett.axisLength, ver], sett.axisStyle, {
        endArrow: "view-direction-arrow",
    });
    drawer.drawLine([hor, ver], [hor, ver - sett.axisLength], sett.axisStyle, {
        endArrow: "view-direction-arrow",
    });

    drawer.drawText([hor + sett.axisLength, ver], sett.horizontalAxisLabel, sett.labelStyle, {
        horiAlign: "center",
        vertAlign: "top",
        horiOffset: 2,
        vertOffset: 4,
    });
    drawer.drawText([hor, ver - sett.axisLength], sett.verticalAxisLabel, sett.labelStyle, {
        horiAlign: "left",
        vertAlign: "middle",
        horiOffset: 5,
        vertOffset: -2,
    });
};